import { createFileRoute } from '@tanstack/react-router';

import { getVirtualTourByToken } from '@/features/estate-media/api/virtual-tour';

export const Route = createFileRoute('/shared/virtualTour/$estateId/$tourId/')({
  loader: async ({ location }) => {
    const { token } = location.search;
    if (!token) throw new Error('Token is required');

    const data = await getVirtualTourByToken(token);
    return data.virtualTour;
  },
  errorComponent: () => {
    return (
      <div className="flex h-screen w-full items-center justify-center">Token has expired</div>
    );
  },
});
